<template>
    <div class="scc-prize-filler" :class="classes" :style="[backgroundImageStyle]">
        <div class="scc-prize-filler__container" :class="icon ? null : 'scc-prize-filler__container--no-icon'">
            <img v-if="icon" :src="icon" alt="icon" class="scc-prize-filler__icon" />
            <span class="scc-prize-filler__title h4">{{ title }}</span>
        </div>
        <SccLink
            class="scc-prize-filler__button"
            button
            large
            align="start"
            :color="backgroundColor === 'white' ? 'secondary' : backgroundColor"
            :inverted="!backgroundImage && backgroundColor !== 'white'"
            :to="buttonLinkTo"
        >
            {{ buttonText }}
        </SccLink>
    </div>
</template>

<script>
import './prize-filler.scss';
import SccLink from '../global/SccLink';

export default {
    name: 'PrizeFiller',
    components: { SccLink },
    __editor: {
        fields: {
            icon: {
                widget: 'media',
            },
            backgroundColor: {
                widget: 'select',
                values: ['primary', 'secondary', 'body', 'white'],
            },
            border: {
                widget: 'select',
                values: ['none', 'left', 'bottom'],
            },
            backgroundImage: {
                widget: 'media',
            },
        },
    },
    props: {
        icon: {
            type: String,
        },
        title: {
            type: String,
            default: 'Wil jij kans maken op deze prachtige prijzen?',
        },
        buttonText: {
            type: String,
            default: 'Speel mee',
        },
        buttonLinkTo: {
            type: String,
            default: 'aanmelden',
        },
        backgroundColor: {
            type: String,
            required: false,
            default: 'primary',
            validator: function(val) {
                return ['primary', 'secondary', 'body', 'white'].includes(val);
            },
        },
        border: {
            type: String,
            default: 'none',
            validator: function(val) {
                return ['none', 'left', 'bottom'].includes(val);
            },
        },
        backgroundImage: {
            type: String,
        },
        fillHeight: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        backgroundImageStyle() {
            return {
                backgroundImage: `url(${this.backgroundImage})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
            };
        },
        classes() {
            return [
                `scc-prize-filler--${this.backgroundColor}`,
                `scc-prize-filler--border-${this.border}`,
                this.fillHeight ? 'scc-prize-filler--fill-height' : null,
            ];
        },
    },
};
</script>
